<template>
  <component :is="$router.currentRoute.params.name" />
</template>

<script>
import TransitionScreens from '@/components/transition'

export default {
  name: 'Transition',
  components: { ...TransitionScreens }
}
</script>
